import * as React from "react";
import styles from "./styles.module.css";
import { Heading } from "@/components/Shared";

type Benefit = {
	heading: string;
	text: string;
};

const InsuranceBenefits: React.FC<{
	headingTitle: string;
	benefits: Array<Benefit>;
}> = ({ headingTitle, benefits }) => {
	const displayBenefits = benefits.map((benefit: Benefit, index: number) => {
		return (
			<div className="ms-5 me-5 mt-4 w-200" key={index}>
				<h2 className={`${styles.text}`}>{`${benefit.heading}`}</h2>

				<p>{`${benefit.text}`}</p>
			</div>
		);
	});

	return (
		<section className={` pt-5 pb-5 text-center bg-blue`}>
			<div className="container-fluid pt-5 pb-5">
				<div>
					<div className={` heading mx-auto mb-5`}>
						<Heading variant={2} isBold={false} title={`${headingTitle}`} />
					</div>
					<div
						className="
            text-center
            d-flex
            flex-wrap
            justify-content-center
            m-auto
          "
					>
						{displayBenefits}
					</div>
				</div>
			</div>
		</section>
	);
};

export default InsuranceBenefits;
